import React, { useState, useEffect } from "react";
import { Row, Col, Input, Spin, Alert } from "antd";
import CouponCode from "./couponCode";
import { applyCoupon } from "../../../api/cartAPI";
import { useAppContext } from "../../../context/AppContext";
import { INBOUND, OUTBOUND } from "../../../utils/constants";

const CouponContainer = props => {
    const {
        state: {
            inbound: { coupons: inboundCoupons },
            outbound: { coupons: outboundCoupons },
        },
        dispatch,
    } = useAppContext();

    const { itemId, handle, usedCoupons } = props;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [reuse, setReuse] = useState(false);
    const [code, setCode] = useState(null);
    const [codes, setCodes] = useState(usedCoupons ? usedCoupons : []);

    /**
     * when coupon loads, check if there're already coupons in context to use (from url search params)
     * if the coupons have not been used, apply it according to its product handle (inbound/outbound)
     */
    useEffect(() => {
        if (handle === INBOUND && inboundCoupons) {
            inboundCoupons.forEach(code => {
                if (!usedCoupons || usedCoupons.indexOf(code) === -1) {
                    // if the coupon has not been used
                    onApplyCoupon(code);
                }
            });
        } else if (handle === OUTBOUND && outboundCoupons) {
            outboundCoupons.forEach(code => {
                if (!usedCoupons || usedCoupons.indexOf(code) === -1) {
                    // if the coupon has not been used
                    onApplyCoupon(code);
                }
            });
        }
    }, []);

    const clearStatus = () => {
        setLoading(false);
        setError(false);
        setCode(null);
        setReuse(false);
    };
    const onApplyCoupon = async code => {
        for (let i = 0; i < codes.length; i++) {
            if (codes[i] === code) {
                setReuse(true);
                return;
            }
        }
        const result = await applyCoupon(itemId, code, dispatch);
        if (result) {
            setCodes([...codes, code]);
        } else {
            setError(true);
        }
    };

    return (
        <>
            <Row type="flex" justify="space-between" align="middle" gutter={8}>
                <Col span={24}>
                    <Input
                        placeholder="Apply promo code here"
                        value={code}
                        onChange={e => {
                            clearStatus(); //reset the status if user start typing
                            setCode(e.target.value);
                        }}
                        addonAfter={
                            <Spin spinning={loading}>
                                <span
                                    style={{ cursor: "pointer", padding: "0 1rem" }}
                                    onClick={() => onApplyCoupon(code)}
                                >
                                    Apply
                                </span>
                            </Spin>
                        }
                    />
                </Col>
            </Row>
            {error && (
                <Alert
                    style={{ marginTop: "0.75rem" }}
                    type={"error"}
                    message={"Please use a valid promo code"}
                    closable
                />
            )}
            {reuse && (
                <Alert
                    style={{ marginTop: "0.75rem" }}
                    type={"error"}
                    message={"The coupon code has already been applied"}
                    closable
                />
            )}
            {codes.map((code, index) => {
                return <CouponCode key={code} code={code} loading={loading} />;
            })}
        </>
    );
};

export default CouponContainer;
